export default "__VITE_ASSET__7f4b6218__"